import { useState } from 'react';
import { Link } from 'react-router';
import { ProblemReport } from '../components/problem-report';
const questions = [
  [
    '기기를 바꿀 때 기록을 옮기려면?',
    '이전 기기의 데이터 화면에서 전체 백업을 받아 공유해요. 새 기기의 같은 화면에서 파일을 골라 미리보기를 확인한 뒤 복원해요.',
    '/settings/data',
  ],
  [
    '총 분량을 모르겠어요.',
    '교재 마지막 쪽 번호를 적어도 돼요. 아직 몰라도 기록은 남길 수 있어요. 플랜과 회독 예측은 총 분량이 있어야 해요.',
    '/plan',
  ],
  [
    '겹친 범위는 어떻게 세나요?',
    '같은 과목·회독에서 1–25쪽과 20–40쪽을 적으면 겹친 쪽을 한 번만 세서 40쪽이에요.',
    '/report',
  ],
  [
    '플랜이 밀렸어요.',
    '플랜에서 재계획을 미리 보고 저장해요. 기존 공부 기록은 유지하고 남은 범위만 나눠요.',
    '/plan',
  ],
  [
    '알림이 안 와요.',
    '알림은 기본 꺼짐이고 앱을 열었을 때만 보여요. 방해 금지 시간도 확인해 주세요. 앱을 닫은 동안은 달력에 넣기를 이용해요.',
    '/settings/reminders',
  ],
  [
    '데이터를 모두 지우려면?',
    '설정의 전체 삭제에서 범위를 확인하고 지워요. 먼저 백업 파일을 받아 주세요.',
    '/settings',
  ],
  [
    '삭제한 기록을 되돌리고 싶어요.',
    '삭제 직후 되돌리기를 누르거나 설정의 휴지통에서 30일 안에 복원해요.',
    '/settings',
  ],
  [
    '회독 지도에 퍼센트가 안 보여요.',
    '과목 총 분량이 아직 없으면 계산하지 않아요. 지도 안 총 분량 입력에서 저장하면 보여요.',
    '/plan',
  ],
  [
    '사진 접근이 꺼졌어요.',
    '권한을 거부해도 글로 오답을 남길 수 있어요. 기기 설정에서 사진 권한을 다시 허용한 뒤 사진을 골라 주세요.',
    '/notes/new',
  ],
  [
    '인터넷이 없어도 쓸 수 있나요?',
    '처음 한 번 앱을 연 뒤 저장된 앱에서는 기록·오답·플랜을 계속 쓸 수 있어요. 온라인 기능은 연결 뒤에 써 주세요.',
    '/logs',
  ],
  [
    '시험에 떨어졌는데 오답을 이어 쓰고 싶어요.',
    '시험 결과를 불합격으로 남기고 다음 회차로 이어가기를 누르면 같은 시험의 날짜만 바뀌고 기록과 오답은 유지돼요.',
    '/settings',
  ],
  [
    '합격 패스와 환불·복원은?',
    '지금은 결제가 꺼져 있고 전체 기능이 무료예요. 한 번 구매하는 이용권을 준비 중이며 구독이 아니에요. 결제를 열 때 환불과 기기 변경 복원을 안내해요.',
    '/pass',
  ],
] as const;
export function HelpPage() {
  const [query, setQuery] = useState('');
  const found = questions.filter((item) => item.join(' ').includes(query.trim()));
  return (
    <div className="pn-page">
      <Link to="/settings">설정으로</Link>
      <h1>도움말</h1>
      <label className="pn-field">
        궁금한 내용 검색
        <input
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="예: 기기, 총 분량, 알림"
        />
      </label>
      {found.length ? (
        found.map(([title, body, path]) => (
          <details key={`${query}:${title}`} open={query.trim().length > 0}>
            <summary>{title}</summary>
            <p>{body}</p>
            <Link className="pn-small-button" to={path}>
              해결 화면 열기
            </Link>
          </details>
        ))
      ) : (
        <p>찾는 답이 없어요. 아래에서 문제를 알려 주세요.</p>
      )}
      <ProblemReport />
    </div>
  );
}
